import HomePage from '../home';

function PageDashboard() {
    return <HomePage />;
}

export default PageDashboard;
